import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import { Modal, ModalControls } from '../../../../../components/Modal';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_UPDATE_SELECTED_VEHICLES } from '../../../constants';
import { Cell } from '../../../../KanbanBoards/cells/Cell';
import { BaseCellComp } from '../../../../KanbanBoards/cells/BaseCellComp';
import {
  addVehicleToBulkActionsList,
  bulkActionAssignVehicleTransport,
  removeVehicleFromBulkActionsList,
  updateSelectedVehicles,
} from '../../../actions';
import { refreshBoards } from '../../../../KanbanBoards/actions';
import { HBox } from '../../../../../components/Box';
import { FormField } from '../../../../../components/FormFields';
import { Check } from '../../../../../components/Icon';
import { Input } from '../../../../../components/Input';

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  trailer_1: '9',
  trailer_2: '10',
  trailer_3: '11',
  trailer_4: '12',
  trailer_5: '13',
  trailer_6: '14',
  trailer_7: '15',
  trailer_8: '16',
  trailer_9: '17',
  trailer_10: '18',
  Intern: '19',
};

export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class TransportOutBulkActionComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.props.reset();
  }

  get action() {
    return this.props.action;
  }

  renderEditableField(property) {
    return (
      <FormField label={property} key={property}>
        <Input
          value={this.state[property]}
          onChange={e => {
            this.onInputChange(e);
            this.setState({ [`showCheck_${property}`]: true });
          }}
          name={property}
        />

        {this.state[property] && this.state[`showCheck_${property}`] ? (
          <Button
            small
            onClick={() => {
              this.props.updateSelectedVehicles(
                [{ propertyName: property, propertyValue: this.state[property] }],
                result => {
                  this.setState({ [`showCheck_${property}`]: false });
                },
              );
            }}
          >
            {this.props.workVehiclesEdit ? <Loader small /> : <Check />}
          </Button>
        ) : null}
      </FormField>
    );
  }

  renderApprove() {
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.Transport_in_eu.modal.title')}>
        <HBox flexWrap center>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            {TransportAssignableOptions.map(a => (
              <Button
                primary={a.value == this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label?.replace(/\_/g, ' ')}
              </Button>
            ))}
          </div>
        </HBox>
        {['amount_transport_eu_out', 'transporter_eu_out', 'date_expected_start_eu_out','amount_of_vehicles_out'].map(property =>
          this.renderEditableField(property),
        )}

        <ModalControls>
          {this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <Button
                primary
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </Button>
              <Button onClick={this.props.reset}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return <Cell>{this.renderApprove()}</Cell>;
  }
}

TransportOutBulkActionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workVehiclesEdit: selectWork(REQUEST_UPDATE_SELECTED_VEHICLES),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
    //
    assign(id, callback) {
      dispatch(
        bulkActionAssignVehicleTransport(ownProps.vehicleIds, `${id}`, true, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    updateSelectedVehicles(properties, callback) {
      dispatch(updateSelectedVehicles(ownProps.vehicleIds, properties, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOutBulkAction = compose(withConnect, withRouter)(TransportOutBulkActionComp);
